/**
 * Replaces all instances of a matching regexp based on the map of replacements.
 *
 * Based on https://github.com/jeresig/node-bulk-replace
 */
export function bulkReplace(str: string, regex: RegExp, map: { [key: string]: string }): string {
    return str.replace(regex, function replacer(match) {
        if (map[match]) {
            return map[match];
        }

        return match;
    });
}
